import youtubeLogo from 'assets/social-icons/youtubeIcon.svg';
import tripAdvisorIcon from 'assets/social-icons/tripAdvisorIcon.svg';
import {
  AFRICA_SAFARI_FACEBOOK,
  AFRICA_SAFARI_INSTAGRAM,
  AFRICA_SAFARI_TRIP_ADVISOR,
  LanguageEnum,
  TANZANIA_SPECIALIST_FACEBOOK,
  TANZANIA_SPECIALIST_INSTAGRAM,
  TANZANIA_SPECIALIST_TRIP_ADVISOR,
} from 'utils/constants.ts';
import googleIcon from 'assets/social-icons/googleIcon.svg';
import instagramIcon from 'assets/social-icons/instagramIcon.svg';
import facebookIcon from 'assets/social-icons/facebookIcon.svg';
import tiktokIcon from 'assets/social-icons/tiktokIcon.svg';

export const getTSSocialMediaByLanguage = (language: LanguageEnum) => {
  return [
    {
      icon: youtubeLogo,
      link: 'https://www.youtube.com/channel/UC3_63AcZOwnQPHjbOb25uKg/videos',
      label: 'YouTube',
    },
    {
      icon: tripAdvisorIcon,
      link: TANZANIA_SPECIALIST_TRIP_ADVISOR[language],
      label: 'Trip Advisor',
    },
    {
      icon: googleIcon,
      link: 'https://www.google.com/search?q=tanzania+specialist',
      label: 'Google',
    },
    {
      icon: instagramIcon,
      link: TANZANIA_SPECIALIST_INSTAGRAM[language],
      label: 'Instagram',
    },
    {
      icon: facebookIcon,
      link: TANZANIA_SPECIALIST_FACEBOOK[language],
      label: 'Facebook',
    },
    {
      icon: tiktokIcon,
      link: 'https://www.tiktok.com/@tanzaniaspecialist?_r=1&_t=ZN-91h3MYhzEcY',
      label: 'Tiktok',
    },
  ];
};

export const getASSocialMediaByLanguage = (language: LanguageEnum) => {
  return [
    {
      icon: youtubeLogo,
      link: 'https://www.youtube.com/@AfricaSafariTrips/videos',
      label: 'Youtube',
    },
    {
      icon: tripAdvisorIcon,
      link: AFRICA_SAFARI_TRIP_ADVISOR[language],
      label: 'Trip Advisor',
    },
    {
      icon: googleIcon,
      link: 'https://www.google.com/search?q=africa+safari+trips',
      label: 'Google',
    },
    {
      icon: instagramIcon,
      link: AFRICA_SAFARI_INSTAGRAM[language],
      label: 'Instagram',
    },
    {
      icon: facebookIcon,
      link: AFRICA_SAFARI_FACEBOOK[language],
      label: 'Facebook',
    },
    {
      icon: tiktokIcon,
      link: 'https://www.tiktok.com/@africasafaritrips.com?_r=1&_t=ZN-91h3PjpW8uN',
      label: 'Tiktok',
    },
  ];
};

export const getLinkByLanguage = (target: Record<LanguageEnum, string>, language: LanguageEnum) => target[language];
